import React, { Children, isValidElement, ReactElement, ReactNode } from 'react';
import DateRangePill, { DateRangePillProps } from './DateRangePill';
import SelectPill, { SelectPillProps } from './SelectPill';
import { SiteFilterPill } from '../../UserAccess/SiteScope/SiteFilterPill';

interface FilterPillGroupProps {
  children: ReactNode;
}

const isApplied = (pill: ReactElement) => {
  if (pill.type === SiteFilterPill) return true;
  if (pill.type === SelectPill) return (pill.props as SelectPillProps).value !== undefined;
  if (pill.type === DateRangePill) return (pill.props as DateRangePillProps).range !== undefined;
  return false;
};

export default function FilterPillGroup({ children }: FilterPillGroupProps) {
  const pills = Children.toArray(children).filter(isValidElement);

  return <>
    {pills.filter(isApplied)}
    {pills.filter(pill => !isApplied(pill))}
  </>;
}
